import React, { useEffect, useState } from "react"; 
import logo from "./assets/hexagulf-logo.png";
import oilgas from '../src/assets/Oil & Gas.webp'
import construction from '../src/assets/Construction & Infrastructure.jpg'
import petrochemical from '../src/assets/Petrochemical & Refining.jpg'
import marine from '../src/assets/Marine Offshore.jpg'
import saudiflag from '../src/assets/saudi.png'
import ukflag from '../src/assets/uk.png'

const FALLBACK_IMAGES = {
  oil: "https://www.oilandgasmiddleeast.com/cloud/2024/02/16/Create_a_rectangular_image_1792x1024_depicting_t.jpeg",
  pipes: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=600&h=400&fit=crop", 
  valves: "https://www.eurovalve.co.uk/images/eurovalve-valve-actuator-specialists-banner.jpg",
  flanges: "https://images.unsplash.com/photo-1581092160607-ee22731af5c4?w=600&h=400&fit=crop",
  bolts: "https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?w=600&h=400&fit=crop",
  steel: "https://images.unsplash.com/photo-1541976076360-2c3e683c8612?w=600&h=400&fit=crop",
  marine: "https://images.unsplash.com/photo-1566024164372-02838bc8ef4e?w=600&h=400&fit=crop",
  instr: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?w=600&h=400&fit=crop",
  yard: "https://images.unsplash.com/photo-1581092580564-896dc578b336?w=600&h=400&fit=crop",
  port: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&h=400&fit=crop",
  refinery: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=600&h=400&fit=crop",
  lab: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=600&h=400&fit=crop",
  lab2: "https://tse1.mm.bing.net/th/id/OIP.JyHxkcgFsjWRaZKzTR5dugHaEW?pid=Api&P=0&h=180",
  lab3: "https://images.unsplash.com/photo-1581092160607-ee22731af5c4?w=600&h=400&fit=crop",
  lab4: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?w=600&h=400&fit=crop",
  software: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop",
  software2: "https://images.unsplash.com/photo-1547658719-da2b51169166?w=600&h=400&fit=crop",
  software3: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
  software4: "https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=600&h=400&fit=crop",
  education: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&h=400&fit=crop",
  healthcare: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=600&h=400&fit=crop",
  hero: "https://images.unsplash.com/photo-1565373679108-4dd20b7d0196?w=1200&h=800&fit=crop"
};

const U = {
  oil: () => FALLBACK_IMAGES.oil,
  pipes: () => FALLBACK_IMAGES.pipes,
  valves: () => FALLBACK_IMAGES.valves,
  flanges: () => FALLBACK_IMAGES.flanges,
  bolts: () => FALLBACK_IMAGES.bolts,
  steel: () => FALLBACK_IMAGES.steel,
  marine: () => FALLBACK_IMAGES.marine,
  instr: () => FALLBACK_IMAGES.instr,
  yard: () => FALLBACK_IMAGES.yard,
  port: () => FALLBACK_IMAGES.port,
  refinery: () => FALLBACK_IMAGES.refinery,
  lab: (i = 1) => i === 1 ? FALLBACK_IMAGES.lab : i === 2 ? FALLBACK_IMAGES.lab2 : i === 3 ? FALLBACK_IMAGES.lab3 : FALLBACK_IMAGES.lab4,
  software: (i = 1) => i === 1 ? FALLBACK_IMAGES.software : i === 2 ? FALLBACK_IMAGES.software2 : i === 3 ? FALLBACK_IMAGES.software3 : FALLBACK_IMAGES.software4,
  education: () => FALLBACK_IMAGES.education,
  healthcare: () => FALLBACK_IMAGES.healthcare,
  logo: () => logo,
  hero: () => FALLBACK_IMAGES.hero
};

/* =========================================
   White Logo Component
========================================= */
const WhiteLogo = ({ 
  className = "", 
  withBackground = false, 
  backgroundShape = "hexagon",
  size = "large" 
}) => {
  const sizeConfig = {
    small: { container: 50, logo: 32, bg: 46 }, 
    medium: { container: 70, logo: 45, bg: 66 }, 
    large: { container: 80, logo: 68, bg: 96 } 
  };

  const config = sizeConfig[size];

  if (withBackground) {
    const BackgroundShape = () => {
      switch (backgroundShape) {
        case "circle":
          return (
            <svg width={config.container} height={config.container} viewBox={`0 0 ${config.container} ${config.container}`} className="logo-bg-shape">
              <circle cx={config.container/2} cy={config.container/2} r={config.bg/2} fill="#FFFFFF" stroke="rgba(255,255,255,0.3)" strokeWidth="1"/>
            </svg>
          );
        case "square":
          return (
            <svg width={config.container} height={config.container} viewBox={`0 0 ${config.container} ${config.container}`} className="logo-bg-shape">
              <rect x="2" y="2" width={config.container-4} height={config.container-4} rx="8" fill="#FFFFFF" stroke="rgba(255,255,255,0.3)" strokeWidth="1"/>
            </svg>
          );
        case "diamond":
          return (
            <svg width={config.container} height={config.container} viewBox={`0 0 ${config.container} ${config.container}`} className="logo-bg-shape">
              <path d={`M${config.container/2},2 L${config.container-2},${config.container/2} L${config.container/2},${config.container-2} L2,${config.container/2} Z`} fill="#FFFFFF" stroke="rgba(255,255,255,0.3)" strokeWidth="1"/>
            </svg>
          );
        case "hexagon":
        default:
          return (
            <svg width={config.container} height={config.container} viewBox={`0 0 ${config.container} ${config.container}`} className="logo-bg-shape">
              <path d={`M${config.container/2},2 L${config.container-2},${config.container*0.3} L${config.container-2},${config.container*0.7} L${config.container/2},${config.container-2} L2,${config.container*0.7} L2,${config.container*0.3} Z`} fill="#FFFFFF" stroke="rgba(255,255,255,0.3)" strokeWidth="1"/>
            </svg>
          );
      }
    };

    return (
      <div className={`logo-with-bg ${className}`} style={{ 
        display: 'inline-flex', 
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}>
        <BackgroundShape />
        <img 
          src={U.logo()} 
          alt="Hexagulf" 
          style={{ 
            height: `${config.logo}px`,
            width: 'auto',
            objectFit: 'contain',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2
          }}
        />
      </div>
    );
  }

  return (
    <img 
      src={U.logo()} 
      alt="Hexagulf" 
      className={className}
      style={{ 
        height: `${config.logo}px`,
        width: 'auto',
        objectFit: 'contain'
      }}
    />
  );
};

/* =========================================
   Language Toggle Button with Flags
========================================= */
const LangToggle = ({ lang, setLang }) => {
  const [open, setOpen] = useState(false);

  const options = [
    { value: "en", label: "English", flag: ukflag, short: "EN" },
    { value: "ar", label: "العربية", flag: saudiflag, short: "AR" },
  ];

  const current = options.find(o => o.value === lang);

  return (
    <div className="lang-toggle-wrapper" style={{ position: 'relative' }}>
      <button
        className="lang-toggle-btn"
        onClick={() => setOpen(!open)}
        aria-label="Select language"
      >
        <img src={current.flag} alt={current.label} className="lang-flag" />
        <span className="lang-short">{current.short}</span>
        <span className="lang-chevron" style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}>▾</span>
      </button>

      {open && (
        <div className="lang-dropdown">
          {options.map(opt => (
            <button
              key={opt.value}
              className={`lang-option${lang === opt.value ? ' active' : ''}`}
              onClick={() => { setLang(opt.value); setOpen(false); }}
            >
              <img src={opt.flag} alt={opt.label} className="lang-flag" />
              <span>{opt.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

/* =========================================
   Image Component with Loading State
========================================= */
const OptimizedImage = ({ src, alt, className, fallback = FALLBACK_IMAGES.oil }) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    setImageSrc(src);
    
    const img = new Image();
    img.src = src;
    img.onload = () => { setLoading(false); setError(false); };
    img.onerror = () => { setLoading(false); setError(true); setImageSrc(fallback); };
  }, [src, fallback]);

  return (
    <div className={`image-container ${loading ? 'image-loading' : ''} ${error ? 'image-error' : ''}`}>
      {loading && (
        <div className="image-skeleton">
          <div className="skeleton-shimmer"></div>
        </div>
      )}
      <img 
        src={imageSrc} 
        alt={alt} 
        className={className}
        style={{ display: loading ? 'none' : 'block' }}
        onLoad={() => setLoading(false)}
        onError={() => { setError(true); setLoading(false); setImageSrc(fallback); }}
      />
    </div>
  );
};

const cx = (...c) => c.filter(Boolean).join(" ");

const STR = {
  LANGS: { en: "English", ar: "العربية" },
  NAV: { 
    home: { en: "Home", ar: "الرئيسية" },
    about: { en: "About Us", ar: "من نحن" },
    divisions: { en: "Our Divisions", ar: "أقسامنا" },
    industries: { en: "Industries", ar: "القطاعات" },
    blog: { en: "Blog", ar: "المدونة" },
    contact: { en: "Contact", ar: "اتصل بنا" },
  },
  HERO: {
    kicker: { en: "Saudi-based • Multi-Industry • Technology • Innovation", ar: "شركة سعودية • متعددة القطاعات • تكنولوجيا • ابتكار" },
    h1: { en: "Hexa-gulf Establishment: Integrated Solutions Under One Roof", ar: "مؤسسةهكسا جلف: حلول متكاملة تحت سقف واحد" },
    lead: { en: "Your trusted partner for industrial supplies, scientific equipment, and technology solutions across Saudi Arabia and the GCC. Quality, reliability, and innovation in every delivery.", ar: "شريكك الموثوق لتوريد المستلزمات الصناعية، المعدات العلمية، وحلول التكنولوجيا في المملكة العربية السعودية ودول الخليج. الجودة، الموثوقية، والابتكار في كل تسليم." },
    cta1: { en: "Request a Quote", ar: "اطلب عرض سعر" },
    cta2: { en: "Explore Divisions", ar: "استكشاف الأقسام" },
  },
};

const DIVISIONS = [
  {
    key: "industrial",
    title: { en: "Industrial Materials & Oilfield Services", ar: "المواد الصناعية وخدمات النفط والغاز" },
    icon: "⚙️",
    cover: U.oil(),
    description: {
      en: "Comprehensive supply of critical materials and components for oil, gas, and industrial sectors with robust logistics and quality assurance.",
      ar: "توريد شامل للمواد والمكونات الحرجة لقطاعات النفط والغاز والصناعة مع خدمات لوجستية قوية وضمان جودة."
    },
    features: {
      en: ["API/ASTM/ASME Standards", "End-to-End Logistics", "Quality Inspection", "Technical Support"],
      ar: ["معايير API/ASTM/ASME", "خدمات لوجستية متكاملة", "التفتيش على الجودة", "الدعم الفني"]
    },
    link: "/divisions/industrial"
  },
  {
    key: "scientific",
    title: { en: "Scientific & Laboratory Equipment", ar: "المعدات العلمية والمختبرات" },
    icon: "🔬",
    cover: U.lab(1),
    description: {
      en: "Advanced laboratory instruments, scientific equipment, and educational tools for research institutions and quality control labs.",
      ar: "أجهزة المختبرات المتقدمة، المعدات العلمية، وأدوات التعليم لمؤسسات البحث ومختبرات ضبط الجودة."
    },
    features: {
      en: ["Research Instruments", "Calibration Services", "Educational Kits", "Maintenance & Support"],
      ar: ["أجهزة البحث العلمي", "خدمات المعايرة", "مجموعات التعليم", "الصيانة والدعم"]
    },
    link: "/divisions/scientific"
  },
  {
    key: "technology",
    title: { en: "Software & Technology Solutions", ar: "حلول البرمجيات والتقنية" },
    icon: "💻",
    cover: U.software(1),
    description: {
      en: "Custom software solutions, enterprise systems, and digital transformation services for industrial and educational sectors.",
      ar: "حلول برمجية مخصصة، أنظمة المؤسسات، وخدمات التحول الرقمي للقطاعات الصناعية والتعليمية."
    },
    features: {
      en: ["Enterprise Software", "E-Learning Platforms", "Process Simulation", "Digital Transformation"],
      ar: ["برمجيات المؤسسات", "منصات التعلم الإلكتروني", "محاكاة العمليات", "التحول الرقمي"]
    },
    link: "/divisions/technology"
  }
];

const INDUSTRIES = [
  {
    key: "oil-gas",
    title: { en: "Oil & Gas", ar: "النفط والغاز" },
    cover: oilgas,
    divisions: ["industrial", "scientific", "technology"],
    description: {
      en: "We supply specialized process equipment, piping systems, valves, and safety instrumentation specifically engineered for petrochemical plants and refineries. Our focus is on delivering corrosion-resistant, high-performance solutions that ensure operational safety, efficiency, and reliability in demanding environments, complying with international API and ASME standards.",
      ar: "نورد معدات عمليات متخصصة، وأنظمة أنابيب، وصمامات، وأجهزة قياس سلامة مصممة خصيصًا لمصانع البتروكيماويات والمصافي. نركز على توفير حلول عالية الأداء ومقاومة للتآكل تضمن السلامة التشغيلية والكفاءة والموثوقية في البيئات المتطلبة، مع الالتزام بمعايير API وASME الدولية."
    }
  },
  {
    key: "petrochemical",
    title: { en: "Petrochemical & Refining", ar: "البتروكيماويات والتكرير" },
    cover: petrochemical,
    divisions: ["industrial", "scientific"],
    description: {
      en: "Specialized equipment and materials for petrochemical plants and refineries with focus on safety and efficiency. We provide corrosion-resistant piping, pressure vessels, heat exchangers, and safety systems that meet international standards for reliable operations in demanding environments.",
      ar: "معدات ومواد متخصصة لمصانع البتروكيماويات والمصافي مع التركيز على السلامة والكفاءة. نقدم أنابيب مقاومة للتآكل وأوعية ضغط ومبادلات حرارية وأنظمة سلامة تلبي المعايير الدولية لتشغيل موثوق في البيئات المتطلبة."
    }
  },
  {
    key: "marine",
    title: { en: "Marine & Offshore", ar: "البحرية والإسفنجية" },
    cover: marine,
    divisions: ["industrial"],
    description: {
      en: "Marine equipment and offshore solutions with class approvals and international standards compliance.",
      ar: "معدات بحرية وحلول إسفنجية باعتمادات التصنيف والامتثال للمعايير الدولية."
    }
  },
  {
    key: "construction",
    title: { en: "Construction & Infrastructure", ar: "البناء والبنية التحتية" },
    cover: construction,
    divisions: ["industrial"],
    description: {
      en: "Structural materials, fasteners, and construction supplies for major infrastructure projects. We provide high-strength steel sections, anchor bolts, structural connectors, and specialized building materials that meet international quality standards for bridges, towers, and large-scale industrial facilities.",
      ar: "مواد إنشائية، مواد تثبيت، ومستلزمات بناء للمشاريع التحتية الكبرى. نقدم مقاطع حديدية عالية المقاومة، ومسامير تثبيت، وموصلات إنشائية، ومواد بناء متخصصة تلبي معايير الجودة الدولية للجسور والأبراج والمنشآت الصناعية واسعة النطاق."
    }
  }
];

const PRODUCTS = [
  {
    key: "pipes",
    division: "industrial",
    cover: U.pipes(),
    title: { en: "Pipes, Tubing & OCTG", ar: "الأنابيب وأنابيب البترول و(OCTG)" },
    bullets: { en: ["Seamless, ERW, LSAW", "API/ASTM/ASME Standards"], ar: ["سلسة، ERW، LSAW", "معايير API/ASTM/ASME"] },
    description: {
      en: "High-quality steel tubulars for drilling, casing, production, and transportation applications in extreme conditions.",
      ar: "أنابيب فولاذية عالية الجودة لتطبيقات الحفر والتغليف والإنتاج والنقل في الظروف القاسية."
    },
    specs: { en: ["API 5CT, API 5L", "ASTM A106/A53", "NACE MR0175"], ar: ["API 5CT، API 5L", "ASTM A106/A53", "NACE MR0175"] },
  },
  {
    key: "valves",
    division: "industrial",
    cover: U.valves(),
    title: { en: "Valves & Actuators", ar: "الصمامات والمشغلات" },
    bullets: { en: ["Gate, Globe, Check, Ball", "Pneumatic/Electric/Hydraulic"], ar: ["بوابة، جلو، فحص، كرة", "هوائية/كهربائية/هيدروليكية"] },
    description: {
      en: "Comprehensive range of valves and actuators for precise flow control in demanding industrial applications.",
      ar: "مجموعة شاملة من الصمامات والمشغلات للتحكم الدقيق في التدفق للتطبيقات الصناعية المتطلبة."
    },
    specs: { en: ["API 6D/600, B16.34", "API 607/6FA", "NACE trims"], ar: ["API 6D/600 وB16.34", "API 607/6FA", "ترايم NACE"] },
  },
  {
    key: "lab-equipment",
    division: "scientific",
    cover: U.lab(2),
    title: { en: "Laboratory Instruments", ar: "أجهزة المختبرات" },
    bullets: { en: ["Spectrophotometers, Microscopes", "Analytical Instruments"], ar: ["مقاييس الطيف، المجاهر", "أجهزة التحليل"] },
    description: {
      en: "Precision laboratory instruments for research, quality control, and scientific analysis across various industries.",
      ar: "أجهزة مختبرات دقيقة للبحث العلمي وضبط الجودة والتحليل العلمي عبر مختلف القطاعات."
    },
    specs: { en: ["ISO 17025 Calibration", "GMP/GLP Compliance", "IQ/OQ/PQ Documentation"], ar: ["معايرة ISO 17025", "امتثال GMP/GLP", "توثيق IQ/OQ/PQ"] },
  },
  {
    key: "software",
    division: "technology",
    cover: U.software(2),
    title: { en: "Enterprise Software", ar: "برمجيات المؤسسات" },
    bullets: { en: ["EAM Systems", "LIMS", "E-Learning Platforms"], ar: ["أنظمة إدارة الأصول", "نظم إدارة المختبرات", "منصات التعلم الإلكتروني"] },
    description: {
      en: "Custom software solutions for asset management, laboratory information, and digital education platforms.",
      ar: "حلول برمجية مخصصة لإدارة الأصول ومعلومات المختبرات ومنصات التعليم الرقمي."
    },
    specs: { en: ["Cloud-Based Solutions", "Custom Development", "Integration Services"], ar: ["حلول سحابية", "تطوير مخصص", "خدمات التكامل"] },
  }
];

const BLOG_POSTS = [
  {
    key: "b1",
    cover: U.oil(),
    title: { 
      en: "The Future of Oil & Gas: Digital Transformation and Sustainability", 
      ar: "مستقبل النفط والغاز: التحول الرقمي والاستدامة" 
    },
    excerpt: {
      en: "Exploring how digital technologies and sustainable practices are reshaping the oil and gas industry in Saudi Arabia.",
      ar: "استكشاف كيفية إعادة تشكيل التكنولوجيات الرقمية والممارسات المستدامة لصناعة النفط والغاز في المملكة العربية السعودية."
    },
    category: { en: "Industry Insights", ar: "رؤى صناعية" },
  },
  {
    key: "b2",
    cover: U.lab(4),
    title: { 
      en: "Advancements in Laboratory Technology for Quality Control", 
      ar: "التطورات في تكنولوجيا المختبرات لضبط الجودة" 
    },
    excerpt: {
      en: "Latest innovations in laboratory instruments and their impact on quality assurance in industrial settings.",
      ar: "أحدث الابتكارات في أجهزة المختبرات وتأثيرها على ضمان الجودة في البيئات الصناعية."
    },
    category: { en: "Scientific Equipment", ar: "المعدات العلمية" },
  }
];

/* ===============================
   MOBILE MENU COMPONENT
=============================== */
const MobileMenu = ({ isOpen, onClose, lang, setLang, active, setActive, t }) => {
  if (!isOpen) return null;

  return (
    <div className="mobile-menu-overlay">
      <div className="mobile-menu">
        <div className="mobile-menu-header">
          <div className="brand">
            <WhiteLogo withBackground={true} backgroundShape="hexagon" size="small" />
          </div>
          <button className="mobile-close" onClick={onClose}>✕</button>
        </div>
        <nav className="mobile-nav-links">
          {[
            ["home", STR.NAV.home],
            ["about", STR.NAV.about],
            ["divisions", STR.NAV.divisions],
            ["industries", STR.NAV.industries],
            ["blog", STR.NAV.blog],
            ["contact", STR.NAV.contact],
          ].map(([id, label]) => (
            <a
              key={id}
              href={`#${id}`}
              className={cx("mobile-nav-item", active === id && "active")}
              onClick={() => { setActive(id); onClose(); }}
            >
              {t(label)}
            </a>
          ))}
          <div className="mobile-lang-selector">
            <button
              className="mobile-lang-option"
              onClick={() => { setLang("en"); onClose(); }}
              style={{ background: lang === 'en' ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.1)' }}
            >
              <img src={ukflag} alt="English" style={{ width: '24px', height: '16px', objectFit: 'cover', borderRadius: '2px' }} />
              <span>English</span>
            </button>
            <button
              className="mobile-lang-option"
              onClick={() => { setLang("ar"); onClose(); }}
              style={{ background: lang === 'ar' ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.1)' }}
            >
              <img src={saudiflag} alt="العربية" style={{ width: '24px', height: '16px', objectFit: 'cover', borderRadius: '2px' }} />
              <span>العربية</span>
            </button>
          </div>
        </nav>
      </div>
    </div>
  );
};

/* ===============================
   MAIN COMPONENT
=============================== */
export default function HexagulfOnePage() {
  const [lang, setLang] = useState("en");
  const isAR = lang === "ar";
  const t = (o) => (Array.isArray(o) ? o : o?.[lang]);
  const [active, setActive] = useState("home");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    division: "industrial"
  });

  // EmailJS status states
  const [sending, setSending] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null); // null | "success" | "error"

  // ⚠️ REPLACE THESE 3 VALUES WITH YOUR EMAILJS CREDENTIALS
  const EMAILJS_SERVICE_ID  = "YOUR_SERVICE_ID";
  const EMAILJS_TEMPLATE_ID = "YOUR_TEMPLATE_ID";
  const EMAILJS_PUBLIC_KEY  = "YOUR_PUBLIC_KEY";

  useEffect(() => {
    document.documentElement.dir = isAR ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [isAR, lang]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "about", "divisions", "industries", "blog", "contact"];
      const scrollY = window.pageYOffset + 100;
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollY > offsetTop && scrollY <= offsetTop + offsetHeight) {
            setActive(section);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setEmailStatus(null);

    // EmailJS template parameters — these match {{variable}} names in your EmailJS template
    const templateParams = {
      from_name:    formData.name,
      from_company: formData.company,
      from_email:   formData.email,
      from_phone:   formData.phone,
      division:     formData.division,
      subject:      formData.subject,
      message:      formData.message,
      to_email:     "sales@hexa-gulf.com",
    };

    try {
      const response = await fetch(
        `https://api.emailjs.com/api/v1.0/email/send`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            service_id:  EMAILJS_SERVICE_ID,
            template_id: EMAILJS_TEMPLATE_ID,
            user_id:     EMAILJS_PUBLIC_KEY,
            template_params: templateParams,
          }),
        }
      );

      if (response.ok) {
        setEmailStatus("success");
        setFormData({ name: "", company: "", email: "", phone: "", subject: "", message: "", division: "industrial" });
        // Auto-hide success message after 6 seconds
        setTimeout(() => setEmailStatus(null), 6000);
      } else {
        setEmailStatus("error");
      }
    } catch (err) {
      setEmailStatus("error");
    } finally {
      setSending(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <style>{`
        :root {
          --primary: #C2185B;
          --primary-dark: #8C0B42;
          --primary-light: #E91E63;
          --secondary: #FF4081;
          --secondary-dark: #C60055;
          --accent: #FF6B35;
          --accent-dark: #E55A2B;
          --dark: #0b1220;
          --dark-light: #1a1a2e;
          --dark-lighter: #16213e;
          --light: #f8fafc;
          --light-dark: #e2e8f0;
          --text: #e5e7eb;
          --text-light: #f1f5f9;
          --text-muted: #9aa4b2;
          --text-dark: #64748b;
          --border: rgba(255, 255, 255, 0.1);
          --border-light: rgba(255, 255, 255, 0.05);

          /* White section text colors */
          --ws-text: #1a1a2e;
          --ws-text-muted: #4a5568;
          --ws-text-light: #2d3748;
          --ws-border: rgba(0,0,0,0.08);
          --ws-card-bg: #ffffff;
          --ws-card-bg-alt: #f8fafc;

          --success: #10b981;
          --warning: #f59e0b;
          --error: #ef4444;
          --font-primary: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
          --font-arabic: 'SF Arabic', 'Segoe UI', system-ui, sans-serif;
          --section-padding: clamp(3rem, 8vw, 6rem);
          --container-max-width: 1280px;
          --border-radius: 12px;
          --border-radius-lg: 20px;
          --border-radius-xl: 30px;
          --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
          --shadow-md: 0 8px 30px rgba(0, 0, 0, 0.12);
          --shadow-lg: 0 20px 50px rgba(0, 0, 0, 0.15);
          --shadow-xl: 0 25px 60px rgba(0, 0, 0, 0.2);
          --transition-fast: 0.2s ease;
          --transition-normal: 0.3s ease;
          --transition-slow: 0.5s ease;
          --z-dropdown: 1000;
          --z-sticky: 1020;
          --z-fixed: 1030;
          --z-modal: 1040;
          --z-tooltip: 1050;
        }

        * { margin: 0; padding: 0; box-sizing: border-box; }

        html { scroll-behavior: smooth; font-size: 16px; }

        body {
          font-family: var(--font-primary);
          background: #ffffff;
          color: var(--ws-text);
          line-height: 1.6;
          overflow-x: hidden;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        [dir="rtl"] { font-family: var(--font-arabic); }

        .container {
          width: 100%;
          max-width: var(--container-max-width);
          margin: 0 auto;
          padding: 0 clamp(1rem, 4vw, 2rem);
        }

        .section {
          padding: var(--section-padding) 0;
          position: relative;
          background: #ffffff;
        }

        .section-alt {
          background: #f8fafc;
        }

        .section-header {
          text-align: center;
          margin-bottom: clamp(2rem, 6vw, 4rem);
        }

        .section-title {
          font-size: clamp(2rem, 5vw, 3.5rem);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 1.5rem;
          background: linear-gradient(135deg, var(--primary), var(--accent));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .section-subtitle {
          font-size: clamp(1.125rem, 2.5vw, 1.5rem);
          color: var(--ws-text-muted);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        /* ===== NAVIGATION ===== */
        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: var(--z-fixed);
          background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary) 100%);
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          transition: all var(--transition-normal);
        }

        .navbar.scrolled {
          background: rgba(194, 24, 91, 0.98);
          box-shadow: var(--shadow-md);
        }

        .nav-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: clamp(70px, 10vw, 80px);
          gap: 2rem;
        }

        .brand {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-weight: 700;
          font-size: clamp(1.25rem, 3vw, 1.5rem);
          color: white;
          text-decoration: none;
          flex-shrink: 0;
        }

        .brand-text { color: white; font-weight: 700; font-size: clamp(1.1rem, 2.5vw, 1.3rem); }

        .logo-with-bg { transition: transform var(--transition-normal); }
        .logo-with-bg:hover { transform: scale(1.05); }
        .logo-bg-shape { filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.3)); }

        .nav-links {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        @media (max-width: 1024px) { .nav-links { gap: 0.25rem; } }

        .nav-link {
          padding: clamp(0.5rem, 2vw, 0.75rem) clamp(0.75rem, 2vw, 1.25rem);
          border-radius: var(--border-radius);
          transition: all var(--transition-fast);
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
          text-decoration: none;
          position: relative;
          white-space: nowrap;
          font-size: clamp(0.875rem, 1.5vw, 1rem);
        }

        .nav-link:hover { background: rgba(255, 255, 255, 0.15); color: white; }
        .nav-link.active { color: white; background: rgba(255, 255, 255, 0.2); }
        .nav-link.active::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 20%;
          right: 20%;
          height: 2px;
          background: white;
          border-radius: 2px;
        }

        /* ===== LANGUAGE TOGGLE ===== */
        .lang-toggle-wrapper { position: relative; margin-left: 0.75rem; }

        .lang-toggle-btn {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.45rem 0.85rem;
          background: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.35);
          border-radius: 50px;
          color: white;
          font-size: 0.875rem;
          font-weight: 600;
          cursor: pointer;
          transition: all var(--transition-fast);
          white-space: nowrap;
        }

        .lang-toggle-btn:hover {
          background: rgba(255, 255, 255, 0.25);
          border-color: rgba(255, 255, 255, 0.5);
        }

        .lang-flag {
          width: 22px;
          height: 15px;
          object-fit: cover;
          border-radius: 3px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.3);
        }

        .lang-short { font-size: 0.8rem; letter-spacing: 0.05em; }

        .lang-chevron {
          font-size: 0.65rem;
          transition: transform var(--transition-fast);
          display: inline-block;
        }

        .lang-dropdown {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          background: white;
          border: 1px solid rgba(0,0,0,0.1);
          border-radius: var(--border-radius);
          box-shadow: 0 8px 24px rgba(0,0,0,0.15);
          overflow: hidden;
          min-width: 150px;
          z-index: var(--z-tooltip);
          animation: fadeIn 0.15s ease;
        }

        [dir="rtl"] .lang-dropdown { right: auto; left: 0; }

        .lang-option {
          display: flex;
          align-items: center;
          gap: 0.6rem;
          width: 100%;
          padding: 0.65rem 1rem;
          background: none;
          border: none;
          cursor: pointer;
          color: var(--ws-text);
          font-size: 0.875rem;
          font-weight: 500;
          transition: background var(--transition-fast);
          text-align: left;
        }

        .lang-option:hover { background: #f8fafc; }
        .lang-option.active { background: rgba(194, 24, 91, 0.07); color: var(--primary); font-weight: 600; }

        [dir="rtl"] .lang-option { text-align: right; }

        /* Mobile Menu Button */
        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: white;
          font-size: 1.5rem;
          cursor: pointer;
          padding: 0.5rem;
          border-radius: var(--border-radius);
          transition: background-color var(--transition-fast);
        }

        .mobile-menu-btn:hover { background: rgba(255, 255, 255, 0.15); }

        /* ===== MOBILE MENU ===== */
        .mobile-menu-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(11, 18, 32, 0.98);
          backdrop-filter: blur(10px);
          z-index: var(--z-modal);
          animation: fadeIn var(--transition-normal);
        }

        .mobile-menu {
          position: fixed;
          top: 0; right: 0; bottom: 0;
          width: min(400px, 90vw);
          background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary) 100%);
          border-left: 1px solid rgba(255, 255, 255, 0.2);
          padding: 2rem;
          overflow-y: auto;
          animation: slideInRight var(--transition-normal);
        }

        [dir="rtl"] .mobile-menu {
          right: auto; left: 0;
          border-left: none;
          border-right: 1px solid rgba(255, 255, 255, 0.2);
          animation: slideInLeft var(--transition-normal);
        }

        .mobile-menu-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 3rem;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        }

        .mobile-close {
          background: none; border: none; color: white;
          font-size: 1.5rem; cursor: pointer; padding: 0.5rem;
          border-radius: var(--border-radius);
          transition: background-color var(--transition-fast);
        }

        .mobile-close:hover { background: rgba(255, 255, 255, 0.15); }

        .mobile-nav-links { display: flex; flex-direction: column; gap: 0.75rem; }

        .mobile-nav-item {
          padding: 1rem 1.5rem;
          border-radius: var(--border-radius);
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all var(--transition-fast);
          color: rgba(255, 255, 255, 0.9);
          text-decoration: none;
          font-weight: 500;
        }

        .mobile-nav-item.active,
        .mobile-nav-item:hover {
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border-color: rgba(255, 255, 255, 0.3);
          transform: translateX(8px);
        }

        [dir="rtl"] .mobile-nav-item.active,
        [dir="rtl"] .mobile-nav-item:hover { transform: translateX(-8px); }

        .mobile-lang-selector {
          margin-top: 2rem;
          padding-top: 2rem;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .mobile-lang-option {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.875rem 1.25rem;
          border-radius: var(--border-radius);
          border: 1px solid rgba(255, 255, 255, 0.25);
          color: white;
          font-size: 0.95rem;
          font-weight: 500;
          cursor: pointer;
          transition: all var(--transition-fast);
          text-align: left;
        }

        .mobile-lang-option:hover { background: rgba(255,255,255,0.2) !important; }

        /* ===== HERO SECTION ===== */
        .hero {
          min-height: 100vh;
          min-height: 100dvh;
          display: flex;
          align-items: center;
          position: relative;
          background: linear-gradient(150deg, #ffffff 0%, #fdf0f5 50%, #fff5f0 100%);
          overflow: hidden;
        }

        /* Decorative background shape */
        .hero::before {
          content: '';
          position: absolute;
          top: -10%;
          right: -5%;
          width: 55%;
          height: 120%;
          background: linear-gradient(135deg, rgba(194, 24, 91, 0.06) 0%, rgba(255, 107, 53, 0.08) 100%);
          border-radius: 40% 60% 60% 40% / 40% 40% 60% 60%;
          z-index: 0;
        }

        .hero::after {
          content: '';
          position: absolute;
          bottom: -15%;
          left: -5%;
          width: 40%;
          height: 70%;
          background: linear-gradient(135deg, rgba(255, 64, 129, 0.05) 0%, rgba(194, 24, 91, 0.04) 100%);
          border-radius: 60% 40% 40% 60% / 60% 60% 40% 40%;
          z-index: 0;
        }

        .hero-content {
          max-width: min(800px, 90vw);
          position: relative;
          z-index: 2;
        }

        .hero-kicker {
          display: inline-block;
          padding: 0.5rem 1.25rem;
          background: rgba(194, 24, 91, 0.07);
          border: 1.5px solid rgba(194, 24, 91, 0.25);
          border-radius: 50px;
          color: var(--primary);
          font-size: clamp(0.75rem, 2vw, 0.875rem);
          font-weight: 600;
          margin-bottom: 1.5rem;
        }

        .hero-title {
          font-size: clamp(2.5rem, 7vw, 4.5rem);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 1.5rem;
          background: linear-gradient(135deg, #1a1a2e 0%, var(--primary) 60%, var(--accent) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-description {
          font-size: clamp(1.125rem, 3vw, 1.375rem);
          color: #4a5568;
          margin-bottom: clamp(2rem, 5vw, 3rem);
          line-height: 1.7;
          max-width: 600px;
        }

        .hero-actions { display: flex; gap: 1rem; flex-wrap: wrap; }

        /* ===== BUTTONS ===== */
        .btn {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: clamp(0.875rem, 2vw, 1rem) clamp(1.5rem, 3vw, 2rem);
          border-radius: 50px;
          font-weight: 600;
          text-decoration: none;
          transition: all var(--transition-normal);
          border: 2px solid transparent;
          cursor: pointer;
          font-size: clamp(0.875rem, 2vw, 1rem);
          white-space: nowrap;
          justify-content: center;
          text-align: center;
        }

        .btn-primary {
          background: linear-gradient(135deg, var(--primary), var(--secondary));
          color: white;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(194, 24, 91, 0.35);
          background: linear-gradient(135deg, var(--primary-dark), var(--secondary-dark));
        }

        .btn-secondary {
          background: transparent;
          color: var(--primary);
          border-color: rgba(194, 24, 91, 0.3);
        }

        .btn-secondary:hover {
          background: rgba(194, 24, 91, 0.06);
          border-color: var(--primary);
          color: var(--primary-dark);
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(194, 24, 91, 0.15);
        }

        /* White section secondary button */
        .btn-secondary-dark {
          background: transparent;
          color: var(--ws-text);
          border-color: rgba(0,0,0,0.2);
        }

        .btn-secondary-dark:hover {
          background: rgba(194, 24, 91, 0.05);
          border-color: var(--primary);
          color: var(--primary);
          transform: translateY(-2px);
        }

        /* ===== ABOUT SECTION - WHITE ===== */
        .about-grid {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
          gap: 3rem;
          align-items: center;
        }

        .about-values-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 1rem;
        }

        .about-value-card {
          background: #f8fafc;
          padding: 1.5rem;
          border-radius: var(--border-radius);
          border: 1px solid rgba(0,0,0,0.07);
          text-align: center;
          transition: all var(--transition-normal);
        }

        .about-value-card:hover {
          background: #C2185B;
          border-color: #C2185B;
          box-shadow: 0 8px 24px rgba(194, 24, 91, 0.35);
          transform: translateY(-3px);
        }

        .about-value-card:hover .about-value-label {
          color: #ffffff;
        }

        .about-value-card:hover .about-value-desc {
          color: rgba(255,255,255,0.8);
        }

        .about-value-label {
          font-size: 0.875rem;
          font-weight: 600;
          color: var(--secondary);
          margin-bottom: 0.5rem;
        }

        .about-value-desc {
          font-size: 0.75rem;
          color: var(--ws-text-muted);
        }

        .about-right-card {
          background: #f8fafc;
          padding: clamp(2rem, 4vw, 3rem);
          border-radius: var(--border-radius-lg);
          border: 1px solid rgba(0,0,0,0.07);
          transition: all var(--transition-normal);
        }

        .about-right-card:hover {
          background: #C2185B;
          border-color: #C2185B;
          box-shadow: 0 12px 40px rgba(194, 24, 91, 0.35);
        }

        .about-right-card:hover .about-right-title,
        .about-right-card:hover .about-list-item-title {
          color: #ffffff;
        }

        .about-right-card:hover .about-list-item-desc {
          color: rgba(255,255,255,0.8);
        }

        .about-right-card:hover .about-list-dot {
          background: rgba(255,255,255,0.8);
        }

        .about-right-title {
          font-size: clamp(1.25rem, 3vw, 1.5rem);
          margin-bottom: 2rem;
          color: var(--ws-text);
          font-weight: 700;
        }

        .about-list-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .about-list-dot {
          width: 8px;
          height: 8px;
          background: var(--accent);
          border-radius: 50%;
          margin-top: 0.5rem;
          flex-shrink: 0;
        }

        .about-list-item-title {
          font-weight: 600;
          color: var(--ws-text);
          margin-bottom: 0.25rem;
          font-size: 0.875rem;
        }

        .about-list-item-desc {
          font-size: 0.75rem;
          color: var(--ws-text-muted);
          line-height: 1.5;
        }

        /* ===== DIVISIONS GRID - ALT BG ===== */
        .divisions-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 350px), 1fr));
          gap: clamp(1.5rem, 4vw, 2.5rem);
          margin-top: 3rem;
        }

        .division-card {
          background: #ffffff;
          border: 1px solid rgba(0,0,0,0.08);
          border-radius: var(--border-radius-lg);
          padding: clamp(2rem, 4vw, 3rem) clamp(1.5rem, 3vw, 2rem);
          text-align: center;
          transition: all var(--transition-normal);
          position: relative;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }

        .division-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 4px;
          background: linear-gradient(135deg, var(--primary), var(--secondary));
        }

        .division-card:hover {
          background: #C2185B;
          transform: translateY(-8px);
          box-shadow: 0 20px 50px rgba(194, 24, 91, 0.4);
          border-color: #C2185B;
        }

        .division-card:hover .division-title {
          color: #ffffff;
        }

        .division-card:hover .division-description {
          color: rgba(255,255,255,0.85);
        }

        .division-card:hover .feature-tag {
          background: rgba(255,255,255,0.2);
          border-color: rgba(255,255,255,0.4);
          color: #ffffff;
        }

        .division-icon { font-size: clamp(2.5rem, 6vw, 3.5rem); margin-bottom: 1.5rem; display: block; }

        .division-title {
          font-size: clamp(1.25rem, 3vw, 1.5rem);
          font-weight: 700;
          margin-bottom: 1rem;
          color: var(--ws-text);
          line-height: 1.3;
        }

        .division-description {
          color: var(--ws-text-muted);
          margin-bottom: 1.5rem;
          line-height: 1.6;
          font-size: clamp(0.875rem, 2vw, 1rem);
        }

        .division-features { display: flex; flex-wrap: wrap; gap: 0.5rem; justify-content: center; }

        .feature-tag {
          padding: 0.375rem 0.75rem;
          background: rgba(255, 64, 129, 0.08);
          border: 1px solid rgba(255, 64, 129, 0.2);
          border-radius: 20px;
          font-size: 0.75rem;
          color: var(--primary);
          font-weight: 500;
        }

        /* ===== INDUSTRIES GRID - WHITE ===== */
        .industries-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr));
          gap: clamp(1.5rem, 4vw, 2rem);
        }

        .industry-card {
          background: #ffffff;
          border-radius: var(--border-radius-lg);
          overflow: hidden;
          transition: all var(--transition-normal);
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }

        .industry-card:hover {
          background: #C2185B;
          transform: translateY(-5px);
          box-shadow: 0 20px 50px rgba(194, 24, 91, 0.4);
          border-color: #C2185B;
        }

        .industry-card:hover .industry-title {
          color: #ffffff;
        }

        .industry-card:hover .industry-description {
          color: rgba(255,255,255,0.85);
        }

        .industry-image { height: 200px; position: relative; overflow: hidden; }

        .industry-image img {
          width: 100%; height: 100%; object-fit: cover;
          transition: transform var(--transition-slow);
        }

        .industry-card:hover .industry-image img { transform: scale(1.05); }

        .industry-content { padding: clamp(1.5rem, 3vw, 2rem); }

        .industry-title {
          font-size: clamp(1.125rem, 2.5vw, 1.25rem);
          font-weight: 700;
          margin-bottom: 0.75rem;
          color: var(--ws-text);
        }

        .industry-description {
          color: var(--ws-text-muted);
          margin-bottom: 1.25rem;
          line-height: 1.6;
          font-size: 0.875rem;
        }

        .division-badge {
          padding: 0.25rem 0.75rem;
          background: rgba(255, 107, 53, 0.08);
          border: 1px solid rgba(255, 107, 53, 0.2);
          border-radius: 12px;
          font-size: 0.75rem;
          color: var(--accent-dark);
          font-weight: 500;
        }

        /* ===== PRODUCTS GRID - ALT BG ===== */
        .products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
          gap: clamp(1.5rem, 4vw, 2rem);
        }

        .product-card {
          background: #ffffff;
          border-radius: var(--border-radius-lg);
          overflow: hidden;
          transition: all var(--transition-normal);
          border: 1px solid rgba(0,0,0,0.08);
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }

        .product-card:hover {
          background: #C2185B;
          transform: translateY(-5px);
          box-shadow: 0 20px 50px rgba(194, 24, 91, 0.4);
          border-color: #C2185B;
        }

        .product-card:hover .product-title {
          color: #ffffff;
        }

        .product-card:hover .product-description {
          color: rgba(255,255,255,0.85);
        }

        .product-card:hover .product-bullet {
          background: rgba(255,255,255,0.2);
          color: #ffffff;
        }

        .product-image { height: 200px; position: relative; overflow: hidden; }

        .product-image img {
          width: 100%; height: 100%; object-fit: cover;
          transition: transform var(--transition-slow);
        }

        .product-card:hover .product-image img { transform: scale(1.05); }

        .product-content { padding: clamp(1.25rem, 3vw, 1.5rem); }

        .product-title {
          font-size: clamp(1rem, 2.5vw, 1.125rem);
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: var(--ws-text);
          line-height: 1.4;
        }

        .product-description {
          color: var(--ws-text-muted);
          font-size: 0.875rem;
          margin-bottom: 1rem;
          line-height: 1.5;
        }

        .product-bullets { display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 1rem; }

        .product-bullet {
          padding: 0.25rem 0.5rem;
          background: rgba(255, 64, 129, 0.08);
          border-radius: 6px;
          font-size: 0.75rem;
          color: var(--primary);
          font-weight: 500;
        }

        /* ===== BLOG GRID - WHITE ===== */
        .blog-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
          gap: clamp(1.5rem, 4vw, 2rem);
        }

        .blog-card {
          background: #ffffff;
          border-radius: var(--border-radius-lg);
          overflow: hidden;
          transition: all var(--transition-normal);
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }

        .blog-card:hover {
          background: #C2185B;
          transform: translateY(-5px);
          box-shadow: 0 20px 50px rgba(194, 24, 91, 0.4);
          border-color: #C2185B;
        }

        .blog-card:hover .blog-title {
          color: #ffffff;
        }

        .blog-card:hover .blog-excerpt {
          color: rgba(255,255,255,0.85);
        }

        .blog-card:hover .blog-meta {
          color: rgba(255,255,255,0.75);
        }

        .blog-image { height: 200px; position: relative; overflow: hidden; }

        .blog-image img {
          width: 100%; height: 100%; object-fit: cover;
          transition: transform var(--transition-slow);
        }

        .blog-card:hover .blog-image img { transform: scale(1.05); }

        .blog-content { padding: clamp(1.5rem, 3vw, 2rem); }

        .blog-meta {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
          font-size: 0.875rem;
          color: var(--ws-text-muted);
          flex-wrap: wrap;
        }

        .blog-category {
          background: var(--accent);
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 600;
        }

        .blog-title {
          font-size: clamp(1.125rem, 2.5vw, 1.25rem);
          font-weight: 700;
          margin-bottom: 0.75rem;
          color: var(--ws-text);
          line-height: 1.4;
        }

        .blog-excerpt {
          color: var(--ws-text-muted);
          line-height: 1.6;
          margin-bottom: 1.25rem;
          font-size: 0.875rem;
        }

        /* ===== CONTACT SECTION - ALT BG ===== */
        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: clamp(2rem, 5vw, 4rem);
          align-items: start;
        }

        .contact-form {
          background: #ffffff;
          padding: clamp(2rem, 4vw, 3rem);
          border-radius: var(--border-radius-lg);
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0 4px 16px rgba(0,0,0,0.06);
          transition: all var(--transition-normal);
        }

        .form-group { margin-bottom: 1.5rem; }

        .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: var(--ws-text);
          font-size: 0.875rem;
        }

        .form-input,
        .form-select,
        .form-textarea {
          width: 100%;
          padding: 0.875rem 1rem;
          background: #f8fafc;
          border: 1px solid rgba(0,0,0,0.12);
          border-radius: var(--border-radius);
          color: var(--ws-text);
          font-size: 1rem;
          transition: all var(--transition-fast);
          font-family: inherit;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: var(--primary);
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(194, 24, 91, 0.1);
        }

        .form-textarea { min-height: 120px; resize: vertical; line-height: 1.5; }

        .contact-info { display: flex; flex-direction: column; gap: 1.5rem; }

        .info-card {
          background: #ffffff;
          padding: clamp(1.5rem, 3vw, 2rem);
          border-radius: var(--border-radius-lg);
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          transition: all var(--transition-normal);
        }

        .info-card:hover {
          background: #C2185B;
          border-color: #C2185B;
          box-shadow: 0 12px 40px rgba(194, 24, 91, 0.35);
          transform: translateY(-3px);
        }

        .info-card:hover .info-title {
          color: #ffffff;
        }

        .info-card:hover .info-item {
          color: rgba(255,255,255,0.85);
        }

        .contact-form:hover {
          border-color: #C2185B;
          box-shadow: 0 8px 30px rgba(194, 24, 91, 0.12), 0 0 0 1px #C2185B;
        }

        .info-title {
          font-size: 1.25rem;
          font-weight: 700;
          margin-bottom: 1.25rem;
          color: var(--ws-text);
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
          color: var(--ws-text-muted);
          font-size: 0.875rem;
        }

        .info-item:last-child { margin-bottom: 0; }

        /* ===== FOOTER ===== */
        .footer {
          background: var(--dark-light);
          border-top: 1px solid var(--border);
          padding: clamp(3rem, 6vw, 4rem) 0 1.5rem;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1fr;
          gap: clamp(2rem, 4vw, 3rem);
          margin-bottom: 3rem;
        }

        .footer-description {
          color: var(--text-muted);
          line-height: 1.6;
          margin-bottom: 1.5rem;
          font-size: 0.875rem;
          margin-top: 1rem;
        }

        .footer-title {
          font-size: 1.125rem;
          font-weight: 700;
          margin-bottom: 1.25rem;
          color: var(--text-light);
        }

        .footer-links { display: flex; flex-direction: column; gap: 0.75rem; }

        .footer-link {
          color: var(--text-muted);
          text-decoration: none;
          transition: color var(--transition-fast);
          font-size: 0.875rem;
        }

        .footer-link:hover { color: var(--secondary); }

        .footer-bottom {
          padding-top: 2rem;
          border-top: 1px solid var(--border);
          text-align: center;
          color: var(--text-muted);
          font-size: 0.875rem;
        }

        /* ===== IMAGE LOADING STATES ===== */
        .image-container { position: relative; overflow: hidden; background: #f0f4f8; width: 100%; height: 100%; }
        .image-loading { background: linear-gradient(90deg, #f0f4f8 25%, #e2e8f0 50%, #f0f4f8 75%); background-size: 200% 100%; animation: loading 1.5s infinite; }
        .image-skeleton { width: 100%; height: 100%; position: relative; overflow: hidden; }
        .skeleton-shimmer { position: absolute; top: 0; left: -100%; width: 100%; height: 100%; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent); animation: shimmer 1.5s infinite; }
        .image-error { background: #f0f4f8; display: flex; align-items: center; justify-content: center; color: #94a3b8; font-size: 0.875rem; }
        .image-container img { width: 100%; height: 100%; object-fit: cover; }

        /* ===== FORM STATUS MESSAGES ===== */
        .form-status {
          display: flex;
          align-items: flex-start;
          gap: 0.875rem;
          padding: 1rem 1.25rem;
          border-radius: var(--border-radius);
          margin-bottom: 1.25rem;
          animation: fadeIn 0.3s ease;
        }

        .form-status-success {
          background: rgba(16, 185, 129, 0.08);
          border: 1.5px solid rgba(16, 185, 129, 0.35);
        }

        .form-status-error {
          background: rgba(239, 68, 68, 0.07);
          border: 1.5px solid rgba(239, 68, 68, 0.3);
        }

        .form-status-icon { font-size: 1.25rem; flex-shrink: 0; margin-top: 0.1rem; }

        .form-status-title {
          font-weight: 700;
          font-size: 0.9rem;
          margin-bottom: 0.2rem;
          color: var(--ws-text);
        }

        .form-status-desc {
          font-size: 0.8rem;
          color: var(--ws-text-muted);
          line-height: 1.5;
        }

        /* Spinner */
        .btn-spinner {
          width: 16px;
          height: 16px;
          border: 2.5px solid rgba(255,255,255,0.4);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
          flex-shrink: 0;
        }

        @keyframes spin { to { transform: rotate(360deg); } }

        /* ===== ANIMATIONS ===== */
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }
        @keyframes slideInLeft { from { transform: translateX(-100%); } to { transform: translateX(0); } }
        @keyframes loading { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
        @keyframes shimmer { 0% { transform: translateX(0); } 100% { transform: translateX(200%); } }

        /* ===== RESPONSIVE ===== */
        @media (min-width: 1440px) { .container { max-width: 1400px; } }

        @media (max-width: 1200px) { .footer-grid { grid-template-columns: 1fr 1fr 1fr; } }

        @media (max-width: 1024px) {
          .nav-links { display: none; }
          .mobile-menu-btn { display: block; }
          .contact-grid { grid-template-columns: 1fr; gap: 3rem; }
          .footer-grid { grid-template-columns: 1fr 1fr; gap: 2.5rem; }
          .about-grid { grid-template-columns: 1fr; }
        }

        @media (max-width: 768px) {
          .section { padding: 4rem 0; }
          .form-row { grid-template-columns: 1fr; gap: 0; }
          .hero-actions { flex-direction: column; align-items: flex-start; }
          .btn { width: 100%; max-width: 300px; }
          .footer-grid { grid-template-columns: 1fr; text-align: center; gap: 2rem; }
        }

        @media (max-width: 640px) {
          .container { padding: 0 1rem; }
          .division-card, .industry-card, .product-card, .blog-card { padding: 1.5rem; }
          .contact-form, .info-card { padding: 1.5rem; }
        }

        @media (max-width: 480px) {
          .hero-title { font-size: 2rem; }
          .hero-description { font-size: 1rem; }
          .section-title { font-size: 1.75rem; }
          .section-subtitle { font-size: 1rem; }
          .divisions-grid, .industries-grid, .products-grid, .blog-grid { grid-template-columns: 1fr; }
          .mobile-menu { width: 100vw; padding: 1.5rem; }
        }

        @media (max-width: 360px) {
          .container { padding: 0 0.75rem; }
          .division-card, .industry-card, .product-card, .blog-card { padding: 1rem; }
          .contact-form { padding: 1rem; }
          .hero-actions .btn { padding: 0.75rem 1rem; }
        }
      `}</style>

      {/* Navigation */}
      <header className="navbar">
        <div className="container nav-inner">
          <a href="#home" className="brand">
            <WhiteLogo withBackground={true} backgroundShape="hexagon" size="large" />
            <span className="brand-text">{isAR ? "هكسا جلف" : "Hexa-gulf"}</span>
          </a>
          
          <nav className="nav-links">
            {[
              ["home", STR.NAV.home],
              ["about", STR.NAV.about],
              ["divisions", STR.NAV.divisions],
              ["industries", STR.NAV.industries],
              ["blog", STR.NAV.blog],
              ["contact", STR.NAV.contact],
            ].map(([id, label]) => (
              <a key={id} href={`#${id}`} className={cx("nav-link", active === id && "active")}>
                {t(label)}
              </a>
            ))}
            
            <LangToggle lang={lang} setLang={setLang} />
          </nav>
          
          <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(true)} aria-label="Open menu">
            ☰
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <MobileMenu
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        lang={lang}
        setLang={setLang}
        active={active}
        setActive={setActive}
        t={t}
      />

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-kicker">{t(STR.HERO.kicker)}</div>
            <h1 className="hero-title">{t(STR.HERO.h1)}</h1>
            <p className="hero-description">{t(STR.HERO.lead)}</p>
            <div className="hero-actions">
              <a href="#contact" className="btn btn-primary">{t(STR.HERO.cta1)}</a>
              <a href="#divisions" className="btn btn-secondary">{t(STR.HERO.cta2)}</a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section - White */}
      <section id="about" className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{isAR ? "من نحن" : "About Hexa-gulf"}</h2>
            <p className="section-subtitle">
              {isAR 
                ? "شركة سعودية رائدة تقدم حلولاً متكاملة عبر قطاعات متعددة" 
                : "A leading Saudi company delivering integrated solutions across multiple industries"
              }
            </p>
          </div>
          
          <div className="about-grid">
            <div>
              <h3 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', marginBottom: '1.5rem', color: 'var(--ws-text)', fontWeight: '700' }}>
                {isAR ? "رؤيتنا ورسالتنا" : "Our Vision & Mission"}
              </h3>
              <p style={{ color: 'var(--ws-text-muted)', marginBottom: '2rem', lineHeight: '1.8', fontSize: 'clamp(0.875rem, 2vw, 1rem)' }}>
                {isAR 
                  ? "نسعى لأن نكون الشريك المفضل في توفير الحلول المتكاملة للقطاعات الصناعية والعلمية والتقنية في المملكة العربية السعودية ومنطقة الخليج. نلتزم بتقديم منتجات وخدمات عالية الجودة تدعم التنمية المستدامة والتحول الرقمي." 
                  : "We strive to be the preferred partner for integrated solutions in industrial, scientific, and technological sectors across Saudi Arabia and the GCC. We are committed to delivering high-quality products and services that support sustainable development and digital transformation."
                }
              </p>
              
              <div className="about-values-grid">
                {[
                  { title: {en: "Quality", ar: "الجودة"}, desc: {en: "International standards", ar: "معايير عالمية"} },
                  { title: {en: "Innovation", ar: "الابتكار"}, desc: {en: "Advanced solutions", ar: "حلول متقدمة"} },
                  { title: {en: "Reliability", ar: "الموثوقية"}, desc: {en: "Trusted partner", ar: "شريك موثوق"} },
                  { title: {en: "Excellence", ar: "التميز"}, desc: {en: "Premium service", ar: "خدمة متميزة"} }
                ].map((value, index) => (
                  <div key={index} className="about-value-card">
                    <div className="about-value-label">{t(value.title)}</div>
                    <div className="about-value-desc">{t(value.desc)}</div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="about-right-card">
              <h3 className="about-right-title">{isAR ? "قيمنا" : "Our Values"}</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                {[
                  { title: {en: "Excellence", ar: "التميز"}, desc: {en: "Commitment to highest standards", ar: "الالتزام بأعلى المعايير"} },
                  { title: {en: "Integrity", ar: "النزاهة"}, desc: {en: "Ethical business practices", ar: "ممارسات الأعمال الأخلاقية"} },
                  { title: {en: "Partnership", ar: "الشراكة"}, desc: {en: "Building long-term relationships", ar: "بناء علاقات طويلة الأمد"} },
                  { title: {en: "Innovation", ar: "الابتكار"}, desc: {en: "Embracing new technologies", ar: "تبني التقنيات الجديدة"} }
                ].map((value, index) => (
                  <div key={index} className="about-list-item">
                    <div className="about-list-dot"></div>
                    <div>
                      <div className="about-list-item-title">{t(value.title)}</div>
                      <div className="about-list-item-desc">{t(value.desc)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Divisions Section - Alt bg */}
      <section id="divisions" className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{isAR ? "أقسامنا" : "Our Divisions"}</h2>
            <p className="section-subtitle">
              {isAR 
                ? "مجموعة متكاملة من الخدمات والحلول تحت سقف واحد" 
                : "A comprehensive suite of services and solutions under one roof"
              }
            </p>
          </div>
          
          <div className="divisions-grid">
            {DIVISIONS.map((division) => (
              <div key={division.key} className="division-card">
                <div className="division-icon">{division.icon}</div>
                <h3 className="division-title">{t(division.title)}</h3>
                <p className="division-description">{t(division.description)}</p>
                <div className="division-features">
                  {t(division.features).map((feature, index) => (
                    <span key={index} className="feature-tag">{feature}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section - White */}
      <section id="industries" className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{isAR ? "القطاعات التي نخدمها" : "Industries We Serve"}</h2>
            <p className="section-subtitle">
              {isAR 
                ? "خبرة واسعة في تلبية احتياجات مختلف القطاعات" 
                : "Extensive expertise in meeting the needs of various sectors"
              }
            </p>
          </div>
          
          <div className="industries-grid">
            {INDUSTRIES.map((industry) => (
              <div key={industry.key} className="industry-card">
                <div className="industry-image">
                  <OptimizedImage src={industry.cover} alt={t(industry.title)} />
                </div>
                <div className="industry-content">
                  <h3 className="industry-title">{t(industry.title)}</h3>
                  <p className="industry-description">{t(industry.description)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Section - Alt bg */}
      <section id="products" className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{isAR ? "منتجاتنا وخدماتنا" : "Products & Services"}</h2>
            <p className="section-subtitle">
              {isAR 
                ? "مجموعة واسعة من المنتجات والخدمات عالية الجودة" 
                : "A wide range of high-quality products and services"
              }
            </p>
          </div>
          
          <div className="products-grid">
            {PRODUCTS.map((product) => (
              <div key={product.key} className="product-card">
                <div className="product-image">
                  <OptimizedImage src={product.cover} alt={t(product.title)} />
                </div>
                <div className="product-content">
                  <h3 className="product-title">{t(product.title)}</h3>
                  <p className="product-description">{t(product.description)}</p>
                  <div className="product-bullets">
                    {t(product.bullets).map((bullet, index) => (
                      <span key={index} className="product-bullet">{bullet}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Section - White */}
      <section id="blog" className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{isAR ? "آخر الأخبار والمقالات" : "Latest News & Insights"}</h2>
            <p className="section-subtitle">
              {isAR 
                ? "ابق على اطلاع بأحدث التطورات في الصناعة" 
                : "Stay updated with the latest industry developments"
              }
            </p>
          </div>
          
          <div className="blog-grid">
            {BLOG_POSTS.map((post) => (
              <article key={post.key} className="blog-card">
                <div className="blog-image">
                  <OptimizedImage src={post.cover} alt={t(post.title)} />
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-category">{t(post.category)}</span>
                    <span>{post.date}</span>
                  </div>
                  <h3 className="blog-title">{t(post.title)}</h3>
                  <p className="blog-excerpt">{t(post.excerpt)}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section - Alt bg */}
      <section id="contact" className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{isAR ? "اتصل بنا" : "Get In Touch"}</h2>
            <p className="section-subtitle">
              {isAR 
                ? "نحن هنا للإجابة على استفساراتك وتقديم الدعم" 
                : "We're here to answer your questions and provide support"
              }
            </p>
          </div>
          
          <div className="contact-grid">
            <div className="contact-form">
              <form onSubmit={handleFormSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">{isAR ? "الاسم" : "Name"}</label>
                    <input type="text" className="form-input" name="name" value={formData.name} onChange={handleInputChange} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">{isAR ? "الشركة" : "Company"}</label>
                    <input type="text" className="form-input" name="company" value={formData.company} onChange={handleInputChange} />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">{isAR ? "البريد الإلكتروني" : "Email"}</label>
                    <input type="email" className="form-input" name="email" value={formData.email} onChange={handleInputChange} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">{isAR ? "الهاتف" : "Phone"}</label>
                    <input type="tel" className="form-input" name="phone" value={formData.phone} onChange={handleInputChange} />
                  </div>
                </div>
                
                <div className="form-group">
                  <label className="form-label">{isAR ? "القسم" : "Division"}</label>
                  <select className="form-select" name="division" value={formData.division} onChange={handleInputChange}>
                    <option value="industrial">{isAR ? "المواد الصناعية" : "Industrial Materials"}</option>
                    <option value="scientific">{isAR ? "المعدات العلمية" : "Scientific Equipment"}</option>
                    <option value="technology">{isAR ? "حلول البرمجيات" : "Software Solutions"}</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label className="form-label">{isAR ? "الموضوع" : "Subject"}</label>
                  <input type="text" className="form-input" name="subject" value={formData.subject} onChange={handleInputChange} required />
                </div>
                
                <div className="form-group">
                  <label className="form-label">{isAR ? "الرسالة" : "Message"}</label>
                  <textarea className="form-textarea" name="message" value={formData.message} onChange={handleInputChange} required></textarea>
                </div>
                
                {/* Success Message */}
                {emailStatus === "success" && (
                  <div className="form-status form-status-success">
                    <span className="form-status-icon">✅</span>
                    <div>
                      <div className="form-status-title">{isAR ? "تم الإرسال بنجاح!" : "Message Sent Successfully!"}</div>
                      <div className="form-status-desc">{isAR ? "سنتواصل معك في أقرب وقت ممكن." : "We'll get back to you as soon as possible."}</div>
                    </div>
                  </div>
                )}

                {/* Error Message */}
                {emailStatus === "error" && (
                  <div className="form-status form-status-error">
                    <span className="form-status-icon">⚠️</span>
                    <div>
                      <div className="form-status-title">{isAR ? "فشل الإرسال" : "Failed to Send"}</div>
                      <div className="form-status-desc">{isAR ? "يرجى المحاولة مرة أخرى أو التواصل عبر البريد الإلكتروني." : "Please try again or contact us directly at sales@hexa-gulf.com"}</div>
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{width: '100%', opacity: sending ? 0.8 : 1, cursor: sending ? 'not-allowed' : 'pointer'}}
                  disabled={sending}
                >
                  {sending ? (
                    <>
                      <span className="btn-spinner"></span>
                      {isAR ? "جارٍ الإرسال..." : "Sending..."}
                    </>
                  ) : (
                    isAR ? "إرسال الرسالة" : "Send Message"
                  )}
                </button>
              </form>
            </div>
            
            <div className="contact-info">
              <div className="info-card">
                <h3 className="info-title">{isAR ? "معلومات التواصل" : "Contact Information"}</h3>
                <div className="info-item"><span>📍</span><span>{isAR ? "الخبر، المملكة العربية السعودية" : "Al Khobar, Saudi Arabia"}</span></div>
                <div className="info-item"><span>📞</span><span>+966 54 633 9981</span></div>
                <div className="info-item"><span>📱</span><span>+966 54 633 9981 (WhatsApp)</span></div>
                <div className="info-item"><span>📧</span><span>sales@hexa-gulf.com</span></div>
                <div className="info-item"><span>🌐</span><span>www.hexa-gulf.com</span></div>
              </div>
              
              <div className="info-card">
                <h3 className="info-title">{isAR ? "ساعات العمل" : "Business Hours"}</h3>
                <div className="info-item"><span>🕒</span><span>{isAR ? "الأحد - الخميس: 8 ص - 5 م" : "Sunday - Thursday: 8 AM - 5 PM"}</span></div>
                <div className="info-item"><span>🕒</span><span>{isAR ? "الجمعة - السبت: مغلق" : "Friday - Saturday: Closed"}</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div>
              <WhiteLogo withBackground={true} backgroundShape="hexagon" size="small" />
              <p className="footer-description">
                {isAR 
                  ? "مؤسسة هكسا جلف - شريكك الموثوق للحلول المتكاملة في المجالات الصناعية والعلمية والتقنية." 
                  : "Hexa-gulf Establishment - Your trusted partner for integrated solutions in industrial, scientific, and technological fields."
                }
              </p>
            </div>
            
            <div>
              <h4 className="footer-title">{isAR ? "روابط سريعة" : "Quick Links"}</h4>
              <div className="footer-links">
                {[["home", STR.NAV.home], ["about", STR.NAV.about], ["divisions", STR.NAV.divisions], ["industries", STR.NAV.industries]].map(([id, label]) => (
                  <a key={id} href={`#${id}`} className="footer-link">{t(label)}</a>
                ))}
              </div>
            </div>
            
            <div>
              <h4 className="footer-title">{isAR ? "الخدمات" : "Services"}</h4>
              <div className="footer-links">
                {DIVISIONS.map((division) => (
                  <a key={division.key} href={`#divisions`} className="footer-link">{t(division.title)}</a>
                ))}
              </div>
            </div>
            
           { /*<div>
              <h4 className="footer-title">{isAR ? "التواصل" : "Connect"}</h4>
              <div className="footer-links">
                <a href="https://www.linkedin.com" className="footer-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                <a href="https://www.twitter.com" className="footer-link" target="_blank" rel="noopener noreferrer">Twitter</a>
                <a href="mailto:sales@hexa-gulf.com" className="footer-link">Email</a>
              </div>
            </div> */}
          </div>
          
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Hexa-gulf Establishment. {isAR ? "جميع الحقوق محفوظة" : "All rights reserved."}</p>
          </div>
        </div>
      </footer>
    </>
  );
}